import appConfig from '../../config/app';
import { getAuthHeaders } from '../fetchers/auth';

export async function updateNewsPost(gymUid, postId, postData) {
  const options = await getAuthHeaders();

  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/news_posts/${postId}`,
    {
      method: 'PATCH',
      headers: {
        ...options,
      },
      body: JSON.stringify({
        title: postData.title,
        body: postData.body,
        notify_users: Boolean(postData.notify_users),
        image_url: postData.image_url || '',
        links: Array.isArray(postData.links) ? postData.links : [],
      }),
    }
  );

  if (!response.ok) {
    const errorPayload = await response.json().catch(() => null);
    throw new Error(errorPayload?.error || 'Unable to update post');
  }

  return response.json();
}
